// src/components/list.ts
import { listAnatomy as parts } from "@chakra-ui/anatomy";
import {
  createMultiStyleConfigHelpers,
  defineStyle
} from "@chakra-ui/styled-system";
var { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);
var baseStyleIcon = defineStyle({
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
});
var baseStyle = definePartsStyle({
  icon: baseStyleIcon
});
var listTheme = defineMultiStyleConfig({
  baseStyle
});

export {
  listTheme
};
